import styled, { css } from 'styled-components';
import {
	media, variables
} from 'styleUtils';

const OutsideWrapper = styled.div`
  position: absolute;
  z-index: 990;
  .SlideIn-appear {
    opacity: 0;
  }
  .SlideIn-appear.SlideIn-appear-active {
    opacity: 1;
    transition: all 0.3s linear;
  }
  .SlideIn-enter {
      opacity: 0;
  }
  .SlideIn-enter.SlideIn-enter-active {
      opacity: 1;
      transition: all 0.2s linear 0.4s;
  }
  .SlideIn-leave {
      opacity: 1.0;
  }
  .SlideIn-leave.SlideIn-leave-active {
      opacity: 0;
      position: absolute;
      width: 100%;
      transition: all 0.2s linear;
  }
`;

const Backdrop = styled.div`
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0,0,0,0.5);
  ${media.desktop`
    padding: ${props => props.fullScreen ? '0px' : '50px'};
  `}
`;

const SkinModal = styled.div`
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
  background-color: white;
  position: relative;
  border-radius: 20px;
  height: auto;
  max-height: 80vh;
  overflow: scroll;
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  margin: 0 auto;
  margin-top: 40px;
  padding: 0px;
  max-width: 365px;
  ${media.desktop`
    height: auto;
    width: auto;
    max-width: 665px;
    margin-top: 7%;
    flex-direction: column;
  `}

  h1 {
    line-height: 42px;
  }
  
  .close {
    position: absolute;
    top: -15px;
    right: 3%;
    height: 22px;
    overflow: hidden;
    padding-bottom: 5px;
    ${media.desktop`
      top: -1%;
    `}
    color: gray;
    font-size: 22px;
    cursor: pointer;
    color: #000000;
    z-index: 1000;
  }
`;

const Wrapper = styled.div`
  max-height: 80vh;
  overflow: scroll;
  padding: 20px;
  padding-top: 30px;
  ${media.desktop`
    display: flex;
    justify-content: center;
    padding: 60px;
    padding-right: 0;
    padding-left: 80px;
    width: 100%;
    overflow: hidden;
  `}
  p {
    font-size: 14px !important;
    margin-bottom: 20px;
  }
  h3 {
    font-size: 12px !important;
    color: rgb(139, 138, 135);
    margin: 20px 0;
    ${media.desktop`
      margin-top: 5px;
    `}
  }
  li {
    font-size: 14px !important;
    margin-top: 7px;
  }
  a {
    font-size: 12px;
    color: rgb(48, 114, 253);
    text-decoration: underline;
    margin-bottom: 50px;
  }
  .mobile {
    ${media.desktop`
      display: none;
    `}
  }
  .non-mobile {
    display: none;
    ${media.desktop`
      display: block;
    `}
  }
`;

const FullFlex = styled.div`
  ${media.desktop`
    display: flex;
    width: 100%
    height: auto;
    margin: auto 0;
    flex-wrap: wrap;
    justify-content: space-between;
  `}
`;

const Address = styled.div`
  width: 100%;
  margin: 0;
  margin-right: 10px;
  ${media.desktop`
    width: 45%;
  `}
  h1 {
    font-size: 18px;
    margin-bottom: 10px;
  }
  h2 {
    font-size: 14px;
    margin-bottom: 5px;
  }
`;

const Button = styled.div`
  background-color: #000000;
  color: white;
  padding: 15px 25px;
  width: fit-content;
  border-radius: 50px;
  font-size: 13px;
  margin-top: 15px;
  margin-bottom: 30px;
  cursor: pointer;
`;

export {
	Address,
	Backdrop,
	Button,
	FullFlex,
	OutsideWrapper,
	SkinModal,
	Wrapper,
};
